import { render, staticRenderFns } from "./MultiDomainInput.vue?vue&type=template&id=7977dea7&"
import script from "./MultiDomainInput.vue?vue&type=script&lang=js&"
export * from "./MultiDomainInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MultiDomainInput.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports